// extracted by mini-css-extract-plugin
export default {"hideUploadArea":"index_hideUploadArea__fXpbE","uploadOuter":"index_uploadOuter__e3F5-"};